export const SESSION_KIND_STANDARD = 'standard'
export const SESSION_KIND_REPAIR = 'repair'

export const getSessionKind = (session) =>
  session?.sessionKind || session?.session_kind || SESSION_KIND_STANDARD

export const getParentSessionId = (session) =>
  session?.parentSessionId || session?.parent_session_id

export const isRepairSession = (session) =>
  getSessionKind(session) === SESSION_KIND_REPAIR

export const isStandardSession = (session) =>
  getSessionKind(session) === SESSION_KIND_STANDARD

export const getSessionDisplayId = (session) => {
  const explicit =
    session?.displaySessionId ||
    session?.display_session_id ||
    session?.displayId ||
    session?.display_id ||
    session?.sessionLabel ||
    session?.session_label

  if (explicit) return explicit

  if (isRepairSession(session)) {
    const sessionId = session?.sessionId ?? ''
    return /-R$/i.test(sessionId) ? sessionId : `${sessionId}-R`
  }

  return session?.sessionId
}

export const getRepairSessionForParent = (sessions = [], parentSessionId) =>
  sessions.find(
    (session) =>
      isRepairSession(session) &&
      getParentSessionId(session) === parentSessionId
  )
